// 홈 '진행 중' 밀도 행 — 시안 C1 `.rw` + denseRow (신고 371 §8).
// 글리프 · 제목 · 번호/연식 · 평가사 · 검차일 · 상태 필. 행 클릭 = 상세로.
import React from 'react';
import { T } from '../../../theme';
import { useT, useLocale } from '../../../../i18n/I18nProvider';
import { orderTitle, orderSubtitle, fmtDate } from '../../fmt';
import LtrText from '../../parts/LtrText';
import SimpleStatusPill from '../../parts/SimpleStatusPill';
import { CancelReasonBadge, ReapplyLink } from '../../parts/CancelReasonBits';
import Thumb from './Thumb';

var row = {
  display: 'flex', alignItems: 'center', gap: 12, padding: '9px 14px', minHeight: 52, width: '100%', minWidth: 0,
  boxSizing: 'border-box', border: 0, borderTop: '1px solid ' + T.bdSoft, background: T.card, cursor: 'pointer',
  fontFamily: 'inherit', textAlign: 'start'
};
var tx = { flex: 1, minWidth: 0 };
var title = { display: 'block', fontSize: 13, fontWeight: 700, letterSpacing: '-.2px', color: T.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var sub = { display: 'flex', alignItems: 'center', gap: 6, fontSize: 11.5, color: T.muted, marginTop: 1, minWidth: 0, overflow: 'hidden' };
var metaWrap = { flex: 'none', display: 'flex', alignItems: 'center', gap: 16 };
var metaCol = { minWidth: 74 };
var metaLabel = { display: 'block', fontSize: 10, fontWeight: 700, color: T.faint, marginBottom: 1 };
var metaVal = { display: 'block', fontSize: 11.5, color: T.body, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };

/// props: { order, first, onClick }
function DenseRow(props) {
  var t = useT();
  var loc = useLocale();
  var o = props.order || {};
  var amber = o.status === 'completed';
  var style = Object.assign({}, row, props.first ? { borderTop: '1px solid transparent' } : null, amber ? { background: T.warnTint } : null);
  var alt = orderSubtitle(t, o);
  return (<button type="button" className="ss-drow" data-order-id={o.id} style={style} onClick={props.onClick}>
    <Thumb order={o} w={40} h={40} />
    <span style={tx}>
      <span style={title}>{orderTitle(t, o)}</span>
      <span style={sub}>
        {alt ? <span>{alt}</span> : null}
        {o.car_number ? <LtrText>{o.car_number}</LtrText> : null}
        {o.car_year ? <LtrText>{o.car_year}</LtrText> : null}
      </span>
      <ReapplyLink order={o} />
    </span>
    <span style={metaWrap}>
      <span style={metaCol}>
        <span style={metaLabel}>{t('evalTableColInspector')}</span>
        <span style={metaVal}>{o.inspector_name || '-'}</span>
      </span>
      <span style={metaCol}>
        <span style={metaLabel}>{t('evalTableColDate')}</span>
        <LtrText style={metaVal}>{fmtDate(loc.locale, o.inspect_date || o.created_at)}</LtrText>
      </span>
    </span>
    <CancelReasonBadge order={o} />
    <SimpleStatusPill status={o.status} />
  </button>);
}

export default DenseRow;
